interface FeedbackAthleteAnswerData {
  id?: number;
  answeredAt?: any;
  mood?: string;
  organizationId?: number;
  athleteId?: number;
  feedbackId?: number;
  timeslotId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  rights?: string[];
}

export class FeedbackAthleteAnswer {
  public static readonly MOOD_WELL: string = 'well';
  public static readonly MOOD_NOT_WELL: string = 'not_well';
  public static readonly NUM_ITEMS: number = 10;

  public static getNonTranslatableFields(): string[] { return ['id', 'answeredAt', 'mood', 'organizationId', 'athleteId', 'feedbackId', 'timeslotId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'answeredAt', 'mood', 'organizationId', 'athleteId', 'feedbackId', 'timeslotId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  answeredAt?: any;
  mood?: string;
  organizationId?: number;
  athleteId?: number;
  feedbackId?: number;
  timeslotId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  rights?: string[];



  public static fromAPI(data: FeedbackAthleteAnswerData): FeedbackAthleteAnswer {
    return new FeedbackAthleteAnswer(data);
  }

  public static fromAPIList(data: FeedbackAthleteAnswerData[]): FeedbackAthleteAnswer[] {
    return data.map((item: FeedbackAthleteAnswerData) => FeedbackAthleteAnswer.fromAPI(item));
  }

  constructor({id, answeredAt, mood, organizationId, athleteId, feedbackId, timeslotId, createDate, createrId, updateDate, updaterId, rights}: FeedbackAthleteAnswerData) {
    this.id = id;
    this.answeredAt = answeredAt;
    this.mood = mood;
    this.organizationId = organizationId;
    this.athleteId = athleteId;
    this.feedbackId = feedbackId;
    this.timeslotId = timeslotId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;

    this.rights = rights;
  }

  public toJson() : FeedbackAthleteAnswerData {
      return {
        id: this.id,
        answeredAt: this.answeredAt,
        mood: this.mood,
        organizationId: this.organizationId,
        athleteId: this.athleteId,
        feedbackId: this.feedbackId,
        timeslotId: this.timeslotId,
        createDate: this.createDate,
        createrId: this.createrId,
        updateDate: this.updateDate,
        updaterId: this.updaterId
      }
  }

}
